import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import genreActions from 'src/redux/actions/genreActions';
import CustomTable from 'src/components/CustomTable';
import { DeleteOutlined, EditOutlined, FileAddOutlined } from '@ant-design/icons';
import genreSelectors from 'src/redux/selectors/genreSelectors';
import { valueFilter, emptyFilter, alphabetSort } from 'src/utils/helpers';
import ModalAddGenre from './ModalAddGenre';
import { Popconfirm } from 'antd';
import CustomDate from 'src/components/CustomDate';
import CustomTags from 'src/components/CustomTags';

const Genres = () => {
  const dispatch = useDispatch();
  const loading = useSelector(genreSelectors.loading);
  const genres = useSelector(genreSelectors.genres);
  const [modalAddGenreVisible, setModalAddGenreVisible] = useState(false);
  const [editingGenre, setEditingGenre] = useState(null);

  const fetchGenres = () => {
    dispatch(genreActions.fetchGenres());
  };

  const deleteGenres = (selectedIds) => {
    dispatch(genreActions.deleteGenres(selectedIds, () => fetchGenres()));
  };

  useEffect(() => {
    fetchGenres();
  }, []);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      width: 200,
      align: 'center',
      searchable: true,
      render: (value, record) => <CustomTags values={record.id} />
    },
    {
      title: 'Color',
      dataIndex: 'color',
      width: 200,
      align: 'center',
      searchable: true,
    },
    {
      title: 'Created at',
      dataIndex: 'createdAt',
      width: 200,
      align: 'center',
      // searchable: true,
      render: (value) => <CustomDate date={value} />
    },
    {
      title: 'Created by',
      dataIndex: 'createdBy',
      width: 200,
      align: 'center',
      searchable: true,
    },
    {
      title: 'Updated at',
      dataIndex: 'updatedAt',
      width: 200,
      align: 'center',
      // searchable: true,
      render: (value) => <CustomDate date={value} />
    },
    {
      title: 'Updated by',
      dataIndex: 'updatedBy',
      width: 200,
      align: 'center',
      searchable: true,
    },
    {
      title: '',
      key: 'actions',
      width: 70,
      fixed: 'right',
      render: (value, record) =>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Popconfirm
            title="Are you sure to delete this genre?"
            onConfirm={() => deleteGenres([record.id])}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined className="action-button" style={{ ...styles.actionButton, backgroundColor: 'red' }} />
          </Popconfirm>
          <EditOutlined className="action-button" style={{ ...styles.actionButton, backgroundColor: 'gold' }} onClick={() => setEditingGenre(record)} />
        </div>
      ,
    }
  ];

  return (
    <div>
      <CustomTable columns={columns} loading={loading} data={genres} onRefresh={fetchGenres} onAdd={() => setModalAddGenreVisible(true)} onDelete={deleteGenres} />
      <ModalAddGenre
        visible={modalAddGenreVisible || editingGenre}
        onCancel={() => {
          setModalAddGenreVisible(false);
          setEditingGenre(null);
        }}
        editingGenre={editingGenre}
      />
    </div>
  )
}

const styles = {
  actionButton: {
    color: 'white',
    padding: 10,
    marginTop: 5,
    marginBottom: 5,
    borderRadius: 5,
    cursor: 'pointer'
  }
};

export default Genres;